export const createHeadingText = firstName =>
  firstName && firstName.length > 0 ? `Hello, ${firstName}!` : `Hello!`
